import { Stack, Typography, IconButton } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { PositionedEvent } from "./CalendarEvent";

export interface ScheduleItemCardProps {
    schedule: PositionedEvent;
    startHour: number;
    subjectName: string;
    onMenuOpen: (event: HTMLElement, schedule: PositionedEvent) => void;
}

export function ScheduleItemCard({ schedule, startHour, subjectName, onMenuOpen }: ScheduleItemCardProps) {
    const top = schedule.start - startHour;
    const height = schedule.end - schedule.start;

    return (
        <Stack 
            direction="column"
            alignItems="flex-start" 
            spacing={0} 
            sx={{
                padding: "2px",
                position: "absolute",
                top: `${top}px`,
                left: `${schedule.left}%`,
                width: `${schedule.width}%`,
                border: "1px solid",
                height: `${height}px`,
            }}>
            <Stack direction="row" alignItems="center" sx={{ width: "100%" }}>
                <IconButton
                    size="small"
                    sx={{
                        border: "1px solid",
                        borderRadius: "4px",
                        height: "20px",
                        width: "20px",
                        color: "primary.contrastText",
                        backgroundColor: "primary.main",
                        padding: "2px",
                        marginRight: "2px",
                    }}
                    onClick={(event) => {
                        onMenuOpen(event.currentTarget, schedule);
                    }}>
                    <MenuIcon sx={{ fontSize: 12 }} />
                </IconButton>
                <Typography sx={{ 
                    color: "primary.main", 
                    fontSize: 12,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "10px",
                    fontWeight: "bold",
                }}>
                    {subjectName}
                </Typography>
            </Stack>
            <Typography sx={{ color: "primary.main", fontSize: 10 }}>
                {schedule.startTime} - {schedule.endTime}
            </Typography>
        </Stack>
    );
}
